<template>
  <div v-if="!online || showBackOnline" class="connection" :class="{ 'active': online }">
    <div class="container">
      <p v-if="!online">{{ $t('general.offline') }}</p>
      <p v-if="showBackOnline">{{ $t('general.online') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'connection',
  data() {
    return {
      online: navigator.onLine,
      showBackOnline: false
    }
  },
  watch: {
    online(v) {
      if (v) {
        this.showBackOnline = true;

        setTimeout(() => {
          this.showBackOnline = false;
        }, 2000);
      }
    }
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.online = type === 'online';
    }
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  }
}
</script>